// extracted by mini-css-extract-plugin
export var buttonContent = "_3s-0";
export var centered = "_3s-1";
export var centeredFlex = "_3s-2";
export var errorText = "_3s-3";
export var icon = "_3s-4";
export var iconButtonContent = "_3s-5";
export var monospace = "_3s-6";
export var padded = "_3s-7";